import { usePageEventContext, withPageEvent } from '../../../shared/flow-event';
import { createInitialState, createTracker } from './tracker';
import type {
  SignupByOtpOneCredentialOptionalFlowEventDefinition,
  SignupByOtpOneCredentialOptionalFlowEventState,
} from './types';

export function useSignupByOtpOneCredentialOptionalFlowEvent() {
  return usePageEventContext<
    SignupByOtpOneCredentialOptionalFlowEventDefinition
  >();
}

export function withSignupByOtpOneCredentialOptionalFlowEvent<
  Props extends object = {}
>() {
  return withPageEvent<
    SignupByOtpOneCredentialOptionalFlowEventDefinition,
    SignupByOtpOneCredentialOptionalFlowEventState,
    Props
  >(createInitialState(), createTracker());
}
